// no-op in the browser
//# sourceMappingURL=polyfill.js.map